import React, { Component } from 'react';
import {Provider} from 'react-redux';
import configureStore from './../store';
import 'semantic-ui-css/semantic.min.css';
import '../assets/styles/index.css';
import Givr from './Givr';


const store = configureStore();

class App extends Component {
  render() {
    return (
        <Provider store={store}>
            <div className="App">
                <Givr />
            </div>
        </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js